import { createFileRoute } from "@tanstack/react-router"
import { ScheduleEditForm } from "../components/settings/schedule-edit-form"
import { useAuth } from "../hooks/use-auth"
import { useScheduledJobs } from "../services/use-scheduled-jobs"
function SchedulePage() {
  const { jobId } = Route.useParams()
  const jobs = useScheduledJobs()
  const auth = useAuth()
  const job = jobs.data?.find((candidate) => candidate.id === jobId)
  return job ? (
    <ScheduleEditForm key={job.id} job={job} canEdit={auth.user?.role === "admin"} />
  ) : null
}
export const Route = createFileRoute("/settings/schedules/$jobId/schedule")({
  component: SchedulePage,
})
